/* eslint-disable @typescript-eslint/no-explicit-any */
export * from './combo-chart.component';
export * from './combo-series-vertical.component';

export const lineChartSeries: any = [
  {
    name: 'Web',
    series: [
      {
        name: 'JAN',
        value: 50,
      },
      {
        value: 80,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        name: 'FEB',
      },
      {
        value: 85,
        name: 'MAR',
      },
      {
        value: 90,
        name: 'APR',
      },
      {
        value: 100,
        name: 'MAY',
      },
      {
        name: 'JUN',
        value: 35,
      },
      {
        name: 'JUL',
        value: 35,
      },
      {
        name: 'AUG',
        value: 45,
      },
      {
        name: 'SEP',
        value: 16,
      },
      {
        name: 'OCT',
        value: 15,
      },
      {
        name: 'NOV',
        value: 55,
      },
      {
        name: 'DEC',
        value: 15,
      },
    ],
  },
  {
    name: 'Mobile Web',
    series: [
      {
        value: 10,
        name: 'JAN',
      },
      {
        value: 20,
        name: 'FEB',
      },
      {
        value: 30,
        name: 'MAR',
      },
      {
        value: 40,
        name: 'APR',
      },
      {
        value: 10,
        name: 'MAY',
      },
      {
        name: 'JUN',
        value: 55,
      },
      {
        name: 'JUL',
        value: 30,
      },
      {
        name: 'AUG',
        value: 15,
      },
      {
        name: 'SEP',
        value: 32,
      },
      {
        name: 'OCT',
        value: 35,
      },
      {
        name: 'NOV',
        value: 25,
      },
      {
        name: 'DEC',
        value: 12,
      },
    ],
  },
  {
    name: 'Mobile App',
    series: [
      {
        value: 2,
        name: 'JAN',
      },
      {
        value: 4,
        name: 'FEB',
      },
      {
        value: 20,
        name: 'MAR',
      },
      {
        value: 30,
        name: 'APR',
      },
      {
        value: 35,
        name: 'MAY',
      },
      {
        name: 'JUN',
        value: 25,
      },
      {
        name: 'JUL',
        value: 45,
      },
      {
        name: 'AUG',
        value: 28,
      },
      {
        name: 'SEP',
        value: 18,
      },
      {
        name: 'OCT',
        value: 45,
      },
      {
        name: 'NOV',
        value: 20,
      },
      {
        name: 'DEC',
        value: 20,
      },
    ],
  },
];

export const barChart: any = [
  {
    name: 'JAN',
    value: 50000,
  },
  {
    name: 'FEB',
    value: 30000,
  },
  {
    name: 'MAR',
    value: 10000,
  },
  {
    name: 'APR',
    value: 5000,
  },
  {
    name: 'MAY',
    value: 500,
  },
  {
    name: 'JUN',
    value: 1000,
  },
  {
    name: 'JUL',
    value: 200,
  },
  {
    name: 'AUG',
    value: 10000,
  },
  {
    name: 'SEP',
    value: 200,
  },
  {
    name: 'OCT',
    value: 200,
  },
  {
    name: 'NOV',
    value: 10000,
  },
  {
    name: 'DEC',
    value: 200,
  },
];

export const comboChartsOptions: any = {
  view: [600, 300],
  showXAxis: true,
  showYAxis: true,
  gradient: false,
  showLegend: true,
  legendTitle: '',
  legendPosition: 'Below',
  showXAxisLabel: false,
  xAxisLabel: '',
  showYAxisLabel: true,
  yAxisLabel: 'Logged In Visits',
  showGridLines: false,
  innerPadding: '10%',
  animations: true,
  barChart,
  lineChartSeries,
  lineChartScheme: {
    name: 'coolthree',
    selectable: true,
    group: 'Ordinal',
    domain: ['#004986', '#F6791E', '#7FC9FD', '#C9EDDA'],
  },

  comboBarScheme: {
    name: 'singleLightBlue',
    selectable: true,
    group: 'Ordinal',
    domain: ['#C9EDDA'],
  },

  showRightYAxisLabel: false,
  yAxisLabelRight: '',
  toolTipContent:
    '<b>Top Digital Channels</b><br><br>The total number of logged-in visits on myCigna using a traditional web browser, mobile browser, or the mobile app',
};
